import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { SharedService } from '../../services/shared.service';
import { Router } from '@angular/router';
const emails = require('../../services/emails.json');

@Component({
  selector: 'app-home',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  name: string = "";
  email: string = "";
  emailConfirm: string = "";
  password: string = "";
  errors: string[] = [];
  errorResponse: string = '';
  errorSocialResponse: string = '';

  constructor(public auth: AuthService, private router: Router) {}

  ngOnInit() {
  }

  canRegister(): boolean {
    return this.name !== '' && this.email !== '' && this.emailConfirm !== '' && this.password !== '';
  }

  validEmail(): boolean {
    if (this.email === '' || this.emailConfirm === '') return false;
    if (this.email !== this.emailConfirm) return false;

    let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(this.email);
  }

  validPassword(): boolean {
    if (this.password === '') return false;

    let regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/;
    return regex.test(this.password);
  }

  submit() {
    this.errors = [];
    if (this.name.length < 4) this.errors.push('invalid-name');
    if (this.validEmail() === false) this.errors.push('invalid-email');
    if (this.validPassword() === false) this.errors.push('invalid-password');

    if (this.errors.length > 0) return false;

    this.auth.toggleSpinner(true);
    this.errorResponse = '';
    this.errorSocialResponse = '';

    this.auth.emailSignUp({
      email: this.email,
      password: this.password
    })
    .then((response) => {
      console.log(response.user.photoURL);
      this.auth.toggleSpinner(false);

      this.auth.updateUserData({
        uid: response.user.uid,
        email: this.auth.encrypt(this.email),
        displayName: this.name,
        photoURL: response.user.photoURL,
        source: 'email',
        role: AuthService.USER_ROLE,
        createdAt: Date.now()
      })

      this.auth.sendEmail({
        to: this.auth.encrypt(this.email),
        subject: emails.register_subject,
        text: this.auth.getEmailTemplate(emails.register.join("")).replace(/\[ユーザー名\]/g, this.name)
      })

      this.auth.getUser().then(res => {
        this.auth.setUser(res)
        this.sendNotification();

        this.router.navigate(['/rooms']);
      })
    })
    .catch(error => {
      this.auth.toggleSpinner(false);
      if (error.message === 'The email address is already in use by another account.') {
        this.errorResponse = 'すでに登録されているメールアドレスです。';
      } else {
        this.errorResponse = 'エラーが発生しました。';
      }
    })
  }

  googleSignUp() {
    this.auth.googleSignUp(AuthService.USER_ROLE)
    .then(() => {
      this.auth.getUser().then(res => {
        this.auth.setUser(res)
        this.sendNotification();

        this.router.navigate(['/rooms']);
      })
    })
    .catch(() => {
      this.errorSocialResponse = "すでに登録されているメールアドレスです。"
    })
  }

  sendNotification() {
    this.auth.sendNotification({
      message: SharedService.LAER_USER_WELCOME,
      type: 'message',
      target: this.auth.user.uid,
      createdAt: Date.now()
    })
  }

  twitterSignUp() {
    this.auth.twitterSignUp(AuthService.USER_ROLE)
    .then(() => {
      this.auth.getUser().then(res => {
        this.auth.setUser(res)
        this.sendNotification();

        this.router.navigate(['/rooms']);
      })
    })
    .catch(e => {
      console.log(e);
      if (e.message === 'no_email') {
        this.errorSocialResponse = "メールアドレスが登録されていないTwitterアカウントは使用できません。"
      } else {
        this.errorSocialResponse = "すでに登録されているメールアドレスです。"
      }
    })
  }

  hasError(value: string): boolean {
    return this.errors.indexOf(value) >= 0;
  }
}
